import { createApp } from 'vue';
import Cart from '@vueApp/views/cart/CartView.vue';

const cartApp = createApp(Cart);
cartApp.mount('#root-cart-view');
